/*eslint-disable*/
import React from "react";
import gql from "graphql-tag";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import GrandInput from "components/Wrappers/materialUIWrappers/components/GrandInput";
import NotificationWrapper from "../../../layouts/hoc/NotificationWrapper";
import AutoFill from "components/Wrappers/materialUIWrappers/components/Autofill";
import { showSnack } from "reducers/NotificationReducer";
import { Field } from "redux-form";
import {
  FormControl,
  Button,
  Card,
  CardContent,
  CardHeader,
  withStyles,
  Grid,
  LinearProgress,
  TextField
} from "@material-ui/core";
import store from "store";
import { Query } from "react-apollo";
import { addOccupations } from "reducers/OccupationsReducer";
import AutofillV2 from "components/Wrappers/materialUIWrappers/components/AutofillV2";
import { quoteIn, astuteIn } from "./FieldIndicators.jsx";

const GET = "sure-quote/Occupations/GET";

const required = value => (value ? undefined : "Required");

const number = value => {
  if (value === undefined) return undefined;

  value = value.replace(/,/g, "").replace(/ /g, "");

  return isNaN(Number(value)) ? "Must be a number" : undefined;
};

const percentage = value => {
  if (value === undefined) return undefined;

  if (isNaN(Number(value))) {
    return "Must be a number";
  }

  if (parseInt(value) > 100 || parseInt(value) < 0) {
    return "Cannot be more than 100 or less than 0";
  }

  return undefined;
};

const occupationQuery = gql`
  {
    Occupations {
      occupations
    }
  }
`;

const CurrencySymbol = "R";

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const charMin3 = value => {
  if (value === undefined || value.trim() === "") return undefined;
  if(value)
  if (value.length < 3) return "Must be at least 3 characters";

  return undefined;
};

const businessOwner = value => 
{
  if (value === undefined || value.trim() === "") return undefined;
  if (value === "Business Owner/Businessman") 
  {
    store.dispatch(
      showSnack({
        message: "If possible please select an occupation that better describe what the client does.",
        color: "danger"
      }))
   
    return;
  }
    
  if (value === undefined || value.trim() === "") return undefined;
  if (value.length < 3) return "Must be at least 3 characters";

  return undefined;
};

const styles = theme => ({});

const form = "client";

class CC_clientOccForm extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }

  render() {
    const validate = [];
    validate.push(required);

    let spousalDetails = null;
    if (store.getState().form.client) {
      let mStatus = store.getState().form.client.values.maritalStatus;
      if (mStatus && mStatus === "Married") {
        spousalDetails = (
          <Grid item xs={12} sm={6} style={{ display: "flex" }}>
            <div>{quoteIn(true)}</div>
            <FormControl fullWidth>
              <Field
                component={FormInput}
                checkValidation={this.props.checkValidation}
                validate={[number]}
                label="Spouse Monthly Income"
                name="spouseIncome"
              />
            </FormControl>
          </Grid>
        );
      }
    }

    return (
      <Query query={occupationQuery}>
        {({ loading, error, data }) => {
          if (loading)
            return (
              <div>
                <LinearProgress />
              </div>
            );
          if (error) return `Error! ${error.message}`;

          if (store.getState().occupations.occupations.length < 1) {
            var occupations = data.Occupations[0];
            store.dispatch(addOccupations({ type: GET, props: occupations }));
            this.forceUpdate();
          }

          return (
            <Card className="contentWithStepper">
              <CardHeader title="Client Occupational Info" />
              <CardContent>
                <div style={{ display: "flex", marginLeft: "23px" }}>
                  {quoteIn()} = Required for Quote
                </div>
                <div style={{ display: "flex", marginLeft: "23px" }}>
                  {astuteIn()} = Required for Astute
                </div>
                <Grid container spacing={24} style={{marginTop:"15px"}}>
                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <label className="labelSmall">
                        Occupation for Quote purposes
                      </label>
                      <Field
                        name={"occupation"}
                        component={AutofillV2}
                        validate={[charMin3, businessOwner]}
                        onItemSelect={() =>
                          this.props.toggleOccupationValid(true)
                          //alert(JSON.stringify( this.name))
                        }
                        textChanged={e =>
                          this.props.toggleOccupationValid(
                            e.target.value.trim() === ""
                          )
                        }
                        autoFillList={_.get(
                          store.getState(),
                          "occupations.occupations",
                          []
                        )}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        component={FormDropdown}
                        label="Highest qualification"
                        name="qualification"
                        options={[
                          {
                            value: "validationError",
                            displayValue: "Please select"
                          },
                          {
                            value: "LessThanMatric",
                            displayValue: "Less than matric"
                          },
                          { value: "Matric", displayValue: "Matric" },
                          {
                            value: "3-yearDiploma",
                            displayValue: "3-year diploma"
                          },
                          {
                            value: "3-yearDegreeOr4-yearDiploma",
                            displayValue: "3-year degree / 4-year diploma"
                          },
                          {
                            value: "4-yearDegreeOrProfessional",
                            displayValue: "4-year degree / Professional"
                          }
                        ]}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <Field
                        name={"qualificationName"}
                        component={FormInput}
                        checkValidation={this.props.checkValidation}
                        label={"Occupation and Qualifications"}
                        onChange={e =>
                          this.props.salaryChangeHandler(e.target.value)
                        }
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        component={FormDropdown}
                        checkValidation={this.props.checkValidation}
                        label="Self Employed"
                        name="selfEmployed"
                        options={[
                          {
                            value: "validationError",
                            displayValue: "Please select"
                          },
                          { value: "N", displayValue: "No" },
                          { value: "Y", displayValue: "Yes" }
                        ]}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"salaryType"}
                        component={FormDropdown}
                        label={"Commission or Fixed Salary?"}
                        options={[
                          {
                            value: "validationError",
                            displayValue: "Please select"
                          },
                          { value: "commission", displayValue: "Commission" },
                          { value: "fixed", displayValue: "Fixed" }
                        ]}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"monthlyIncome"}
                        component={GrandInput}
                        checkValidation={this.props.checkValidation}
                        label={"Monthly income (Gross)"}
                        validate={[number]}
                        onChange={e =>
                          this.props.salaryChangeHandler(e.target.value)
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <Field
                        name={"calculatedMonthlyIncomeAT"}
                        component={GrandInput}
                        label={"Monthly After Tax Income (Calculated)"}
                        fixedValue={this.props.afterTaxIncome}
                        readOnly={true}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <Field
                        name={"actualMonthlyIncomeAT"}
                        component={GrandInput}
                        validate={[number]}
                        checkValidation={this.props.checkValidation}
                        label={"Actual monthly after tax income"}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        component={FormDropdown}
                        label="Tax dispensation"
                        name="TaxDispensation"
                        options={[
                          {
                            value: "validationError",
                            displayValue: "Please select"
                          },
                          {
                            value: "NaturalPerson",
                            displayValue: "Natural person"
                          },
                          {
                            value: "TaxPayingInstitution",
                            displayValue: "Tax-paying institution"
                          },
                          {
                            value: "TaxExemptInstitution",
                            displayValue: "Tax-exempt institution"
                          },
                          { value: "Trust", displayValue: "Trust" }
                        ]}
                      />
                    </FormControl>
                  </Grid>

                  {spousalDetails}

                  <Grid item xs={12} sm={12}>
                    <label className="labelSmall">Occupational Duties</label>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"Admin"}
                        component={FormInput}
                        validate={[percentage]}
                        checkValidation={this.props.checkValidation}
                        label={"Admin % *"}
                        isRequired={true}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"Travel"}
                        component={FormInput}
                        validate={[percentage]}
                        checkValidation={this.props.checkValidation}
                        label={"Travel % *"}
                        isRequired={true}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"ManualLabour"}
                        component={FormInput}
                        validate={[percentage]}
                        checkValidation={this.props.checkValidation}
                        label={"Manual Labour % *"}
                        isRequired={true}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6} style={{ display: "flex" }}>
                    <div>{quoteIn(true)}</div>
                    <FormControl fullWidth>
                      <Field
                        name={"Supervision"}
                        component={FormInput}
                        validate={[percentage]}
                        checkValidation={this.props.checkValidation}
                        label={"Supervision % *"}
                        isRequired={true}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                <br />
              </CardContent>
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default withStyles(styles)(CC_clientOccForm);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_clientOccForm.jsx